/* eslint-disable react/prop-types */
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import clsx from 'clsx';

import renderRoutes from 'helpers/renderRoutes';

import {
  Background,
  CheckLogin,
  CollectionView,
  ContactView,
  DirectoryView,
  FastFactsView,
  FavoriteView,
  HeaderSub,
  HomeView,
  MessageCenter,
  MobileWarning,
  NewHomeView,
  NotFoundView,
  NotLoggedInView,
  RetainContentView,
  RetainView,
  Search,
  ServicesView,
  SubAppView,
  ToolboxView,
  TrainingContentView,
  TrainingView,
} from 'C4';
import { appName, brandName } from 'settings';

const loginPages = ['training', 'retain'];
const paths = `(${loginPages.join('|')})`;

const SubRouter = ({ onSelect }) => (
  <div className={clsx('subRouter', brandName)} id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={({ location: { pathname } }) =>
        !pathname.match(/main\/(directory|discover|fasttrack)(\/.*?)$/g) && <HeaderSub pathname={pathname} />
      }
    />
    <div className={clsx('viewContainer', appName)}>
      <Background type="image" darken={window.location.pathname !== '/main'} />
      <Switch>
        {renderRoutes({
          '/main': { exact: true, component: HomeView },
          // '/main/landing': { exact: true, render: (props) => <NewHomeView {...props} onSelect={onSelect} /> },
          '/main/mob': { exact: true, component: MobileWarning },
          '/main/services/contact': ContactView,
          '/main/:type(discover|retain)': {
            exact: true,
            type: {
              discover: TrainingView,
              retain: RetainView,
            },
          },
          '/main/search': Search,
          '/main/messages': MessageCenter,
          '/main/:type(discover|retain)/:chapterId/:pageId': {
            exact: true,
            type: {
              discover: TrainingContentView,
              retain: RetainContentView,
            },
          },
          '/main/favorites': FavoriteView,
          '/main/subApp': SubAppView,
          '/main/:type(reference|tools|services)': {
            exact: true,
            type: {
              reference: FastFactsView,
              tools: ToolboxView,
              services: ServicesView,
            },
          },
          '/main/directory': DirectoryView,
          '/main/:type(reference|tools)/:contentType(images|videos)': CollectionView,
          '/main/:type(reference|tools)/brochures/:item?': CollectionView,
          '/main/off': NotLoggedInView,
        })}
        <Route component={NotFoundView} />
      </Switch>
    </div>
  </div>
);

export default withRouter(SubRouter);
